'use strict';

module.exports = [
    function () {

        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            template: `
            <div class="rm-side-menu-group" flex layout="column" layout-align="start start" ng-transclude></div>
            `
        };
    }
];

